import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import PhoneLink from 'components/common/PhoneLink'
import Media from 'components/common/Media'
import { ServiceIcon } from 'components/common/ServiceIcon'

const ServiceItem = ({
  storePhoneNumber,
  formattedStorePhoneNumber,
  service: {
    name,
    iconName,
    qty
  }
}) =>
  <Item>
    <QuotedServiceIcon iconName={ iconName } />

    <Content>
      <ServiceName>
        {name}
      </ServiceName>

      <Quantity>
        {`Qty: ${qty}`}
      </Quantity>

      <Text>Call store for price</Text>

      <Media.Mobile>
        <StyledPhoneLink number={ formattedStorePhoneNumber } />
      </Media.Mobile>
      <Media.Desktop>
        <CallStore>{ storePhoneNumber }</CallStore>
      </Media.Desktop>
    </Content>
  </Item>

ServiceItem.propTypes = {
  formattedStorePhoneNumber: PropTypes.string,
  service: PropTypes.shape(),
  storePhoneNumber: PropTypes.string
}

export default ServiceItem

const Item = styled.li`
  position: relative;
  padding: 24px 0 24px 53px;
`

const Content = styled.div`
  width: 100%;
`

const QuotedServiceIcon = styled(ServiceIcon)`
  position: absolute;
  top: 24px;
  left: 0;
  width: 45px;
  height: auto;
`

const ServiceName = styled.p`
  margin: 0 0 12px 0;
  font-size: 16px;
  line-height: 1.2;
`

const Quantity = styled.p`
  margin: 0 0 12px 0;
  font-size: 16px;
  line-height: 1.2;
`

const Text = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.2;
`

const CallStore = styled.p`
  display: block;
  margin: 0;
  font-weight: 700;
  line-height: 1.2;
  font-size: 14px;
`

const StyledPhoneLink = styled(PhoneLink)`
  display: block;
  text-decoration: none;
  font-weight: 700;
  line-height: 1.2;
  font-size: 14px;
`
